import { NavLink } from 'react-router-dom'
import { Button } from 'app/components/ui/button'

type WelcomeSuccessScreenProps = {
  message: string
}

export function WelcomeSuccessScreen({ message }: WelcomeSuccessScreenProps) {
  return (
    <div
      data-testid="welcome-success-screen"
      className="grid h-dvh place-items-center overflow-y-auto bg-surface-subtle p-4"
    >
      <div className="w-full max-w-md rounded-xl border border-default bg-surface p-8 text-center shadow-sm sm:p-12">
        <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-green-100">
          <span className="text-3xl">🎉</span>
        </div>
        <p className="mb-6 text-base text-default">{message}</p>
        <Button variant="primary" size="lg" asChild className="w-full">
          <NavLink to="/login">Sign in</NavLink>
        </Button>
      </div>
    </div>
  )
}
